import Image from "next/image";
import IMAGES from "@/public/assets/img";

const KeyFeatures = ({ data }) => {
  const { sectionTitle, cases } = data;

  return (
    <section className="py-sp-100 sm:py-sp-big">
      <div className="container sm:px-2">
        <div className="relative min-h-[400px] sm:min-h-[270px] rounded-xl">

          {/* Background Image */}
          <Image
            priority
            src={IMAGES.dealerFinancing.featureBg}
            width={1100}
            height={500}
            alt="Feature Background"
            className="absolute inset-0 max-w-none w-full h-full"
          />

          {/* Content */}
          <div className="relative z-10 py-20 px-16 sm:py-6 sm:px-4">
            <h2 className="text-center text-textxl font-medium text-baseBlack mb-12 sm:mb-5 sm:text-xl">
              {sectionTitle}
            </h2>

            <div className="flex flex-wrap">
              {cases.map((item) => (
                <div
                  key={item.id}
                  className="flex items-center gap-2 w-1/2 mb-4 sm:w-full"
                >
                  <Image
                    src={IMAGES.ImportFactoring.yes}
                    width={24}
                    height={24}
                    alt="check"
                  />

                  <p className="text-black text-lg font-medium sm:text-sm">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default KeyFeatures;